import { lighten } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  foundRoot: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '90%',
    borderRadius: 12,
    padding: '3px 6px',
    backgroundColor: ({ colour }) =>
      colour ? lighten(`#${colour}`, 0.8) : 'white',
    '& label': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight: 8,
    flexShrink: 0,
    backgroundColor: ({ colour }) => (colour ? `#${colour}` : 'white'),
    border: ({ colour }) => (colour ? `` : 'solid 1px black')
  }
}))

export default useStyles
